import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { Nullable } from "../../../../../shared/src/@types/util";
import { EUFinanceReactQueryKey } from "../../../../models/EUFinanceReactQueryKey";
import { useEUFinanceCaseAttachmentService } from "../../services/EUFinanceCaseAttachmentService";
import { EUFinanceCaseAttachmentsPermissions } from "../../services/EUFinanceCaseAttachmentService/models/EUFinanceCaseAttachmentsPermissions";

export type UseCaseAttachmentByIdResult =
  UseQueryResult<EUFinanceCaseAttachmentsPermissions>;

const useCaseAttachmentsPermissionsByCaseId = (
  caseId: Nullable<string>
): UseCaseAttachmentByIdResult => {
  const caseAttachmentService = useEUFinanceCaseAttachmentService();

  return useQuery<EUFinanceCaseAttachmentsPermissions>({
    queryKey: [
      ...EUFinanceReactQueryKey.GET_CASE_ATTACHMENTS_PERMISSIONS,
      caseId,
    ],
    queryFn: () =>
      caseAttachmentService.getCaseAttachmentsPermissionsByCaseId(caseId),
  });
};

export default useCaseAttachmentsPermissionsByCaseId;
